import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/owners', data)
    .then(response => {
      return response.data
    })
}
function update(data, id) {
  return axios.patch(`/owners/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  getOwners(params) {
    return axios.get('/owners', { params: params })
      .then(response => {
        return response.data
      })
  },
  destroy(id) {
    return axios.delete(`/owners/${id}`)
  }
}
